import { Tabs as MantineTabs, Divider, Group, Box } from "@mantine/core";
import classes from "./Tabs.module.css";
import WithPermission from "../../../features/auth/components/WithPermission/WithPermission";

const Tabs = ({
  currentTab,
  onChange,
  tabs,
  children,
  variant = "pills",
  /** When true with underline variant: tab row on page bg; children on page bg (white only inside nested cards). */
  separateContent = false,
}) => {
  const isUnderline = variant === "underline";
  const stacked = separateContent && isUnderline;

  const tabList = (
    <MantineTabs.List
      className={`${classes.tabsList} ${stacked ? classes.tabsListStacked : ""}`}
    >
      <Group
        className={classes.tabsContainer}
        gap={0}
        wrap="nowrap"
        justify="flex-start"
      >
        {tabs.map((tab) => (
          <WithPermission roleRequired={tab.role} key={tab.value}>
            <MantineTabs.Tab
              value={tab.value}
              leftSection={
                isUnderline ? undefined : <img src={tab.icon} alt={`${tab.label} icon`} />
              }
              className={
                currentTab === tab.value
                  ? isUnderline
                    ? classes.activeTabUnderline
                    : classes.activeTab
                  : isUnderline
                  ? classes.tabUnderline
                  : classes.tab
              }
            >
              {tab.label}
            </MantineTabs.Tab>
          </WithPermission>
        ))}
      </Group>
    </MantineTabs.List>
  );

  const divider = (
    <Divider
      my={isUnderline ? 0 : "xl"}
      className={isUnderline ? classes.dividerUnderline : classes.divider}
    />
  );

  return (
    <MantineTabs
      value={currentTab}
      onChange={onChange}
      variant="unstyled"
      classNames={classes}
      styles={
        stacked
          ? {
              list: {
                padding: 0,
                margin: 0,
                gap: 0,
                alignItems: "stretch",
              },
              tabLabel: {
                padding: 0,
                margin: 0,
              },
            }
          : undefined
      }
    >
      {stacked ? (
        <>
          <Box
            pt={16}
            pb={4}
            px={{ base: 12, sm: 0 }}
            mb={16}
            style={{ overflow: "hidden", background: "transparent" }}
          >
            {tabList}
            {divider}
          </Box>
          <Box style={{ background: "transparent" }}>{children}</Box>
        </>
      ) : (
        <>
          {tabList}
          {divider}
          {children}
        </>
      )}
    </MantineTabs>
  );
};

export default Tabs;